import { createFileRoute } from "@tanstack/react-router";
import AdminMssqlSync from "@/pages/admin/AdminMssqlSync";

export const Route = createFileRoute("/_adminLayout/admin/mssql-sync")({
  component: AdminMssqlSync,
});
